import { render, staticRenderFns } from "./ScreeningProcessApplicant.vue?vue&type=template&id=9126bfa6&scoped=true&"
import script from "./ScreeningProcessApplicant.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessApplicant.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProcessApplicant.vue?vue&type=style&index=0&id=9126bfa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9126bfa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VSlideXReverseTransition,VSlideXTransition,VSpacer,VSwitch})
